"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _carbonComponentsReact = require("carbon-components-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LabelFactory = _interopRequireDefault(require("../../common/FormElement/LabelFactory"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ".text-area {\n  position: relative;\n  margin-bottom: 1.5rem; }\n  .text-area .bx--label {\n    color: #4c4c4c; }\n  .text-area .limit {\n    position: absolute;\n    right: 0;\n    top: 0;\n    font-size: 12px;\n    line-height: 1.34; }\n";
  const fileName = "TextArea_TextArea";
  const element = document.querySelector("style[data-sass-component='TextArea_TextArea']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const TextArea = props => {
  const maxValueLength = props.limit;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'text-area'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'limit'
  }, props.value.length, "/", maxValueLength), /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TextArea, {
    value: props.value,
    labelText: _LabelFactory.default.create(props.label, props.required),
    onChange: event => {
      const inputValue = event.target.value;
      const value = inputValue.length <= maxValueLength ? inputValue : inputValue.substring(0, maxValueLength);
      props.onChange(event, value);
    },
    placeholder: props.placeholder,
    helperText: props.helperText,
    invalid: Boolean(props.invalidText),
    invalidText: props.invalidText,
    disabled: props.disabled
  }));
};
TextArea.defaultProps = {
  type: 'TextArea' // todo, https://stackoverflow.com/q/72446985/4840661
};
TextArea.propTypes = {
  id: _propTypes.default.string.isRequired,
  label: _propTypes.default.string.isRequired,
  value: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  placeholder: _propTypes.default.string,
  helperText: _propTypes.default.string,
  required: _propTypes.default.bool,
  invalidText: _propTypes.default.string,
  limit: _propTypes.default.number,
  disabled: _propTypes.default.bool
};
TextArea.defaultProps = {
  limit: 10000
};
var _default = exports.default = TextArea;